import agencytypeReducer from './agencytypeReducer';
import assignmentPlacementReducer from './assignmentPlacementReducer';
import assignmentReducer from './assignmentReducer';
import authorityReducer from './authorityReducer';
import badgeReducer from './badgeReducer';
import bannerReducer from './bannerReducer';
import batchReducer from './batchReducer';
import categoryReducer from './categoryReducer';
import classroomReducer from './classroomReducer';
import { combineReducers } from 'redux';
import courseCategoryReducer from './courseCategoryReducer';
import courseReducer from './courseReducer';
import coursedetailReducer from './coursedetailReducer';
import coursehistoryReducer from './coursehistoryReducer';
import coursetypeReducer from './coursetypeReducer';
import departmentReducer from './departmentReducer';
import echelonReducer from './echelonReducer';
import faqReducer from './faqReducer';
import jointypeReducer from './jointypeReducer';
import knowledgeReducer from './knowledgeReducer';
import mailerReducer from './mailerReducer';
import manualReducer from './manualReducer';
import menuReducer from './menuReducer';
import participantbufferReducer from './participantbufferReducer';
import provinceReducer from './provinceReducer';
import questionTypeReducer from './questionTypeReducer';
import quizPlacementReducer from './quizPlacementReducer';
import quizReducer from './quizReducer';
import regencyReducer from './regencyReducer';
import roleReducer from './roleReducer';
import sectionReducer from './sectionReducer';
import submenuReducer from './submenuReducer';
import surveyReducer from './surveyReducer';
import surveytypeReducer from './surveytypeReducer';
import transcodingReducer from './transcodingReducer';
import unitReducer from './unitReducer';
import unittypeReducer from './unittypeReducer';
import userReducer from './userReducer';
import visibilitytypeReducer from './visibilityReducer';
import webinarPlacementReducer from './webinarPlacementReducer';
import webinarReducer from './webinarReducer';
import zoomReducer from './zoomReducer';
import zoomhostReducer from './zoomhostReducer';
import zoomjwtReducer from './zoomjwtReducer';
import zoomsessionReducer from './zoomsessionReducer';
import apbnzoneReducer from './apbnzoneReducer';
import postReducer from './postReducer';
import apbnregistrantReducer from './apbnregistrantReducer';
import meetingattendancesessionReducer from './meetingattendancesessionReducer';
import meetinghistoryReducer from './meetinghistoryReducer';
import profilevalidationReducer from './profilevalidationReducer';
import rtcpostReducer from './rtcpostReducer';
import fileReducer from './fileReducer';
import classroomMeetingReducer from './classroomMeetingReducer';
import articleReducer from './articleReducer';
import semantikReducer from './semantikReducer';
import classroomArticleReducer from './classroomArticleReducer';
import classroomPresenceReducer from './classroomPresenceReducer';
import classroomSuplementReducer from './classroomSuplementReducer';
import oapbnReducer from './oapbnReducer';
import authReducer from './authReducer';
import programReducer from './programReducer';
import programsubjectReducer from './programsubjectReducer';
import programdocumentReducer from './programdocumentReducer';
import programCodeReducer from './programCodeReducer';
import calendarReducer from './calendarReducer';
import programValidationReducer from './programValidationReducer';
import programhistoryReducer from './programhistoryReducer';

const appDataReducer = combineReducers({
  AuthorityData: authorityReducer,
  CategoryData: categoryReducer,
  RoleData: roleReducer,
  UserData: userReducer,
  QuizData: quizReducer,
  QuestionTypeData: questionTypeReducer,
  ManualData: manualReducer,
  EchelonData: echelonReducer,
  FaqData: faqReducer,
  CourseData: courseReducer,
  BatchData: batchReducer,
  CourseTypeData: coursetypeReducer,
  VisibilityTypeData: visibilitytypeReducer,
  JoinTypeData: jointypeReducer,
  SectionData: sectionReducer,
  UnitData: unitReducer,
  AssignmentData: assignmentReducer,
  UnitTypeData: unittypeReducer,
  ClassroomData: classroomReducer,
  CourseHistoryData: coursehistoryReducer,
  CourseDetailData: coursedetailReducer,
  QuizPlacementData: quizPlacementReducer,
  AssignmentPlacementData: assignmentPlacementReducer,
  AgencyData: agencytypeReducer,
  BannerData: bannerReducer,
  CourseCategoryData: courseCategoryReducer,
  KnowledgeData: knowledgeReducer,
  DepartmentData: departmentReducer,
  ProvinceData: provinceReducer,
  RegencyData: regencyReducer,
  BadgeData: badgeReducer,
  MailerData: mailerReducer,
  MenuData: menuReducer,
  SubMenuData: submenuReducer,
  SurveyData: surveyReducer,
  SurveyTypeData: surveytypeReducer,
  ParticipantBufferData: participantbufferReducer,
  TranscodingData: transcodingReducer,
  ZoomHostData: zoomhostReducer,
  ZoomSessionData: zoomsessionReducer,
  ZoomData: zoomReducer,
  ZoomJwtData: zoomjwtReducer,
  WebinarData: webinarReducer,
  WebinarPlacementData: webinarPlacementReducer,
  ApbnZoneData: apbnzoneReducer,
  PostData: postReducer,
  ApbnRegistrantData: apbnregistrantReducer,
  MeetingAttendanceSessionData: meetingattendancesessionReducer,
  MeetingHistoryData: meetinghistoryReducer,
  ValidationTypeData: profilevalidationReducer,
  RtcPostData: rtcpostReducer,
  MediaData: fileReducer,
  ClassMeetData: classroomMeetingReducer,
  ArticleData: articleReducer,
  SemantikData: semantikReducer,
  ClassroomArticleData: classroomArticleReducer,
  ClassroomPresenceData: classroomPresenceReducer,
  ClassroomSuplementData: classroomSuplementReducer,
  OapbnData: oapbnReducer,
  AuthData: authReducer,
  ProgramData: programReducer,
  ProgramSubjectData: programsubjectReducer,
  ProgramDocumentData: programdocumentReducer,
  ProgramCodeData: programCodeReducer,
  CalendarData: calendarReducer,
  ProgramValidationData: programValidationReducer,
  ProgramHistoryData: programhistoryReducer
});

export default appDataReducer;
